var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgF(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "850.39px",
    height: "850.39px",
    viewBox: "0 0 850.39 850.39",
    enableBackground: "new 0 0 850.39 850.39",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.407,348.901c0,20.398-16.534,36.935-36.938,36.935c-20.398,0-36.937-16.537-36.937-36.935 c0-20.401,16.539-36.938,36.937-36.938C451.873,311.963,468.407,328.5,468.407,348.901z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.407,551.786c0,13.464-14.827,24.387-33.128,24.387h-11.96c-18.297,0-33.131-10.923-33.131-24.387V416.31 c0-13.47,14.834-24.388,33.131-24.388h11.96c18.301,0,33.128,10.918,33.128,24.388V551.786z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 348.862,
    y: 507.951,
    width: 12.182,
    height: 243.787
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1F24",
    points: "473.246,751.73 473.246,639.513 361.028,639.513  "
  })), /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F6DB0C",
    points: "361.044,639.51 361.036,751.728 473.254,751.736  "
  })), /*#__PURE__*/React.createElement("g", null)))), /*#__PURE__*/React.createElement("path", {
    id: "leftHand",
    d: "M357.614,503.39c8.159,0.001,14.774-6.614,14.773-14.772v-66.053c0-8.161-6.615-14.775-14.774-14.775l0,0 c-8.158,0-14.776,6.614-14.776,14.775l0,66.053C342.837,496.775,349.455,503.39,357.614,503.39L357.614,503.39z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 576.43,
    y: 405.075,
    width: 243.786,
    height: 12.183
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1F24",
    points: "820.21,529.459 707.992,529.459 707.992,417.241  "
  })), /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F6DB0C",
    points: "707.989,417.257 820.207,417.248 820.216,529.466  "
  })), /*#__PURE__*/React.createElement("g", null)))), /*#__PURE__*/React.createElement("path", {
    id: "rightHand",
    d: "M473.254,413.499c0,8.158,6.615,14.772,14.774,14.773l66.051,0.001c8.163-0.002,14.78-6.617,14.78-14.774 l0,0c0-8.164-6.616-14.777-14.781-14.777l-66.049,0C479.87,398.722,473.254,405.335,473.254,413.499L473.254,413.499z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF);
export default __webpack_public_path__ + "static/media/f.71cc1ed03ce1f0636924377dbe21fc99.svg";
export { ForwardRef as ReactComponent };